import Controller from '@ember/controller';
import { service } from '@ember/service';
import type StateService from 'garaje/services/state';
import urlBuilder from 'garaje/utils/url-builder';

export default class LocationOverviewCommunicationsThreatDashboardController extends Controller {
  @service declare state: StateService;

  /**
   * Company-wide threat dashboard. Embeds the migrated emno-fe app at its
   * `global-overview` pseudo-location (vs. a real location id at the
   * per-location `communications.alerts` route). Same `/entrypoint` redirect
   * handoff as the per-location embed — see urlBuilder.emno.
   */
  get iframeUrl(): string {
    const companyId = this.state.currentCompany.id;

    return urlBuilder.emno.embeddedThreatDashboardUrl(companyId, 'global-overview');
  }
}
